import { cn } from '@/lib/utils';
import { IErrorMessageProps } from '@/@types/ui';

export function ErrorMessage({ title = 'Error', message, className }: IErrorMessageProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-destructive bg-destructive/10 p-4',
        className
      )}
      role="alert"
    >
      <h3 className="text-sm font-medium text-destructive mb-1">{title}</h3>
      <p className="text-sm text-destructive/90">{message}</p>
    </div>
  );
}
